export const contentAreaStyles = {
  container: {
    flex: 1,
    position: 'relative',
  },
};
